import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export interface WishlistItem {
    id: string;
    name: string;
    price: number;
    image: string;
    slug: string;
    variantId?: string;
}

interface WishlistStore {
    items: WishlistItem[];
    addItem: (item: WishlistItem) => void;
    removeItem: (itemId: string) => void;
    toggleItem: (item: WishlistItem) => void;
    clear: () => void;
    isInWishlist: (itemId: string) => boolean;
    isOpen: boolean;
    openWishlist: () => void;
    closeWishlist: () => void;
}

export const useWishlist = create<WishlistStore>()(
    persist(
        (set, get) => ({
            items: [],

            addItem: (item) => set((state) => {
                if (state.items.some((i) => i.id === item.id)) return state;
                return { items: [...state.items, item] };
            }),

            removeItem: (itemId) => set((state) => ({
                items: state.items.filter((i) => i.id !== itemId)
            })),

            toggleItem: (item) => {
                const state = get();
                if (state.items.some((i) => i.id === item.id)) {
                    state.removeItem(item.id);
                } else {
                    state.addItem(item);
                }
            },

            clear: () => set({ items: [] }),

            isInWishlist: (itemId) => {
                return get().items.some((item) => item.id === itemId);
            },

            // Drawer Control
            isOpen: false,
            openWishlist: () => set({ isOpen: true }),
            closeWishlist: () => set({ isOpen: false }),
        }),
        {
            name: 'bold-eco-wishlist', // localStorage key
            // Don't persist isOpen state
            partialize: (state) => ({ items: state.items }),
        }
    )
);
